import { IRolesTableData, Parent } from '@/entities/admin-app/roles';
import { CustomerSettingType } from '@/services/enums';
import { Nullable } from 'vitest';

export type CustomerSettingsParams = {
  CustomerId: number;
  Type: CustomerSettingType;
  Settings: {
    UserIp?: {
      Enabled: boolean;
      IpAdresses?: string[];
    };
    AdminIp?: {
      Enabled: boolean;
      IpAdresses?: string[] | null;
    };
    SessionDuration?: number;
    PassEnterCount?: {
      Enabled: boolean;
      Count: number;
    };
    Ldap?: {
      Enabled: boolean;
      Server?: string | null;
      Login?: string | null;
      Password?: string | null;
      Mapping?: {
        Login: string;
        FirstName: string;
        SecondName: string;
        Email: string;
        Phone: string;
        BirthDate: string;
        PrincipalName: string;
      };
    };
    Smtp?: {
      Email: {
        Name: string;
        Id: number;
        Count: number;
      };
    };
    PasswordSecurity?: {
      MinLength: number;
      UseCapitalLetters: boolean;
      UseDigital: boolean;
      UseSpecialCharacters: boolean;
      UseLowLetter: boolean;
      UseAllowedSpecialCharacters: boolean;
    };
    QuotaRules?: number;
    ExternalLinksSettings?: {
      IsDisabled: boolean;
      IsEnabledRules: boolean;
      Rules: SettingsRule[];
    };
    ExportUserActionsSettings?: ExportUserActionsSettings;
    RoomsRoleAccess?: RoomsRoleAccess;
  };
};

export type SettingsRule = {
  Id: number;
  Roles: IRolesTableData[];
  ExternalLinkRuleDirectory: number[] | null;
  Password: {
    MinLength: number;
    IsDigit: boolean;
    IsLow: boolean;
    IsHigh: boolean;
  } | null;
  MaxActivePeriod: number | null;
};

export type SaveCustomerSettingsResponse = {
  Status: number;
  Message: string; // Описание результата выполнения
};

export type GetCustomerParams = {
  id?: number;
  extended?: boolean;
};

export interface GetCustomerResponse {
  Response: {
    TypeName: string;
    Data: CustomerResponse;
  };
  Status: number;
  StatusCode: number;
}

export type CustomerResponse = {
  Id: number;
  Title: string;
  Company: string;
  Parent: null | Parent;
  Roles: {
    Name: string;
    Id: number;
    Count: number;
  }[];
  Children: {
    Name: string;
    Id: number;
    Count: number;
  }[];
  DateOfCreate: string;
  IsParentSettings: boolean;
  UsersCount: number;
  Settings: {
    UserIp?: {
      Enabled: boolean;
      IpAdresses: string[] | null;
    };
    AdminIp?: {
      Enabled: boolean;
      IpAdresses: string[] | null;
    };
    SessionDuration?: number;
    PassEnterCount?: {
      Enabled: boolean;
      Count: number;
    };
    Ldap?: {
      Enabled: boolean;
      Server: string | null;
      Login: string | null;
      Password: string | null;
      Mapping?: {
        Login: string;
        FirstName: string;
        SecondName: string;
        Email: string;
        Phone: string;
        BirthDate: string;
        PrincipalName: string;
      };
    };
    Smtp?: {
      Host: string | null;
      Port: number;
      Login: string | null;
      Password: string | null;
      ViewUserName: string | null;
      SenderAddres: string | null;
      User?: {
        Name: string;
        Id: number;
        Count: number;
      };
      Email?: {
        Name: string;
        Id: number;
        Count: number;
      };
    };
    PasswordSecurity?: {
      MinLength: number;
      UseCapitalLetters: boolean;
      UseDigital: boolean;
      UseSpecialCharacters: boolean;
      UseLowLetter: boolean;
      UseAllowedSpecialCharacters: boolean;
    };
    QuotaRules?: number;
    ExternalLinksSettings?: ExternalLinksSettings;
    RoomsRoleAccess?: RoomsRoleAccess;
    ExportUserActionsSettings?: ExportUserActionsSettings;
  };
};

export interface ExternalLinksSettings {
  IsDisabled: boolean;
  IsEnabledRules: boolean;
  Rules: SettingsRule[] | null;
}

export enum ExportUserActionsSettingsFormat {
  CEF,
  LEEF
}

export interface ExportUserActionsSettings {
  Host: Nullable<string>;
  Port?: Nullable<number>;
  IsEnabled: boolean;
  Format: ExportUserActionsSettingsFormat;
}

export interface RoomsRole {
  Name: string;
  Id: number;
}

export interface RoomsRoleAccess {
  IsDisabled: boolean;
  Roles: RoomsRole[];
}

export type CreateCustomerRequest = {
  Company: string;
  Title: string;
  Parent: Parent;
};

export type CreateCustomerResponse = {
  Id: number;
  Company: string;
  Title: string;
  Parent: Parent;
};

export type UpdateCustomerRequest = {
  Id: number;
  Company: string;
  Title: string;
  Parent: Parent;
};

export type UpdateCustomerResponse = {
  Id: number;
  Company: string;
  Title: string;
  Parent: Parent;
};
